"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signature = void 0;
class Signature {
    constructor(buffer) {
        this.buffer = buffer;
    }
    static fromHex(hex) {
        return new Signature(Buffer.from(hex, "hex"));
    }
    hex() {
        return this.buffer.toString("hex");
    }
}
exports.Signature = Signature;
//# sourceMappingURL=signature.js.map